import type { TabState } from '../types/state'

/**
 * Per-tab actionable counts. Single source of truth so the tab-strip pill badges and the browser
 * tab title (see hooks/useTabTitle) never drift — change a filter here and both surfaces follow.
 */

/** Open agent requests on a tab — the asked-questions (+ approval) badge count. Resolved requests
 *  are already pruned from `pendingRequests`; here we just drop ones whose load was archived. */
export const countOpenRequests = (tab: TabState): number => tab.pendingRequests.filter((r) => !r.archived_load).length

// The counts every badge/total reads. Unread is page-independent (`tab.unreadCount`, seeded from
// GET /tabs/counts then kept live by the unread socket handlers) — never re-summed from the loaded
// page, which would under-count a paginated tab. Pending isn't paginated, so it's live from the full
// request set once fetched, else the startup seed. Both make un-opened tabs show a count upfront.
export const tabUnreadCount = (tab: TabState): number => tab.unreadCount
export const tabPendingCount = (tab: TabState): number => (tab.requestsFetched ? countOpenRequests(tab) : tab.seedPending)
